import { Injector } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ConfigService } from '../services/config-service/config-service.service';
import { getWidgetPropertiesUrlByPageUrl } from './zone-url.utils';

/**
 * Navigates the user to a specified full-page URL, handling redirection
 * based on the target zone's container type (e.g., page or modal).
 * * This function first extracts the navigation parameters (zoneToNavigate and
 * urlToNavigate) from the provided 'pageUrl'. It then uses the ConfigService
 * to transform the URL if the target is intended to open in a modal or page view.
 *
 * Example of a full-page URL: '/zones/profile/bank-statements-account-file-type'
 */
export function redirectToPageWithUrl(pageUrl: string, injector: Injector, options?: NavigationExtras) {
  const widgetProperties = getWidgetPropertiesUrlByPageUrl(pageUrl);

  const zoneToNavigate = widgetProperties?.['zoneToNavigate'];
  const urlToNavigate = widgetProperties?.['urlToNavigate'];

  if (zoneToNavigate && urlToNavigate) {
    const router = injector.get(Router);
    const configService = injector?.get(ConfigService);

    if (configService) {
      const url = configService.reRouteIfModal(zoneToNavigate, urlToNavigate);
      router.navigateByUrl(url, options);
    } else {
      // ConfigService not found
      console.error(
        `[redirectToPageWithUrl] Error: ConfigService not found in injector for pageUrl: ${pageUrl}`,
        { pageUrl, zoneToNavigate, urlToNavigate },
      );
    }
  } else {
    //  Navigation properties not found
    console.error(
      `[redirectToPageWithUrl] Error: 'zoneToNavigate' or 'urlToNavigate' not found for pageUrl: ${pageUrl}`,
      { pageUrl, widgetProperties },
    );
  }
}
